// Gameservers translations

const gameservers = {
  en: {
    gameservers: {
      title: "Game",
      titleHighlight: "Servers",
      subtitle: "Instant setup, DDoS protection, and PrePaid billing. Choose your game and get started in minutes.",
      search_placeholder: "Search games...",
      search_clear: "Clear search",
      noResults: "No games found for",
      noResults2: "Try a different search term.",
      orderNow: "Order Now",
      learnMore: "Learn More",
      badge_popular: "Popular",
      // Feature badges
      feat_ddos: "DDoS Protection",
      feat_setup: "Instant Setup",
      feat_prepaid: "PrePaid – No Contract",
      feat_support: "Ticket Support",
      feat_mods: "Mod Support",
      // Why section
      whyTitle: "Why GameServer from us?",
      why1_title: "Instant Setup",
      why1_desc: "Your server is ready within minutes – start playing right away.",
      why2_title: "DDoS Protection",
      why2_desc: "All game servers include enterprise-grade DDoS protection.",
      why3_title: "Mod Support",
      why3_desc: "Full access to your server files – install any mod or plugin.",
      why4_title: "PrePaid Model",
      why4_desc: "No contracts, no auto-renewals. Play as long as you want.",
      // CTA
      ctaTitle: "Ready to play?",
      ctaDesc: "Choose your game and get your server up and running in minutes – DDoS protected and without contracts.",
      ctaBtn: "View all game servers",
    },
  },

  de: {
    gameservers: {
      title: "Game",
      titleHighlight: "Server",
      subtitle: "Sofort-Setup, DDoS-Schutz und Prepaid-Abrechnung. Wähle dein Spiel und leg in Minuten los.",
      search_placeholder: "Spiele suchen...",
      search_clear: "Suche löschen",
      noResults: "Keine Spiele gefunden für",
      noResults2: "Versuche einen anderen Suchbegriff.",
      orderNow: "Jetzt bestellen",
      learnMore: "Mehr erfahren",
      badge_popular: "Beliebt",
      feat_ddos: "DDoS-Schutz",
      feat_setup: "Sofort-Setup",
      feat_prepaid: "PrePaid – kein Vertrag",
      feat_support: "Ticket Support",
      feat_mods: "Mod-Unterstützung",
      whyTitle: "Warum Gameserver bei uns?",
      why1_title: "Sofort-Setup",
      why1_desc: "Dein Server ist innerhalb von Minuten bereit – sofort losspielen.",
      why2_title: "DDoS-Schutz",
      why2_desc: "Alle Gameserver sind mit Enterprise-DDoS-Schutz ausgestattet.",
      why3_title: "Mod-Unterstützung",
      why3_desc: "Voller Zugriff auf deine Server-Dateien – installiere beliebige Mods oder Plugins.",
      why4_title: "Prepaid-Modell",
      why4_desc: "Keine Verträge, keine automatische Verlängerung. Spiele so lange du möchtest.",
      ctaTitle: "Bereit zum Spielen?",
      ctaDesc: "Wähle dein Spiel und bring deinen Server in Minuten zum Laufen – DDoS-geschützt und ohne Verträge.",
      ctaBtn: "Alle Gameserver ansehen",
    },
  },
};

export default gameservers;
